<template>
    <div>
        <div>
            <label for="programSelector">Program:</label>
            <v-select
                    id="programSelector"
                    :getOptionLabel="option =>option.label"
                    @input="setActiveProgram"
                    :options="programs"
                    :value="selectedProgram"
                    :disabled="selectedExchangeRateSnapshot!=null && !selectedExchangeRateSnapshot.frozen"
            ></v-select>
            <label for="snapSelector">Exchange rate:</label>
            <v-select
                    id="snapSelector"
                    :getOptionLabel="option => formatDate(option)"
                    @input="setActiveSnapshot"
                    :options="exchangeRateSnapshots"
                    :value="selectedExchangeRateSnapshot"
                    :disabled="selectedExchangeRateSnapshot!=null && !selectedExchangeRateSnapshot.frozen"
            ></v-select>

            <div  v-if="selectedExchangeRateSnapshot && !selectedExchangeRateSnapshot.frozen">
                <label for="commentField">Comment:</label><br>
                <input id="commentField" class="vs__dropdown-toggle commentField" type="text" v-model="selectedExchangeRateSnapshot.snapshotComment">
            </div>





            <table v-if="selectedExchangeRateSnapshot">
                <thead>
                <th>Currency</th>
                <th>Market price</th>
                </thead>
                <tbody v-if="selectedExchangeRateSnapshot.frozen">
                <tr :key="pair.sourceCurrency" v-for="pair of selectedExchangeRateSnapshot.rates">
                    <td>{{pair.sourceCurrency}} / {{pair.targetCurrency}}</td>
                    <td style="text-align: right">{{pair.exchangeRate}}</td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr :key="idx" v-for="(pair,idx) in selectedExchangeRateSnapshot.rates">
                    <td class="currencyColumn"><v-select
                        id="fromc"
                        @input="(v)=>{pair.sourceCurrency=v;}"
                        :options="selectableCurrencies"
                        :value="pair.sourceCurrency"
                    ></v-select> / <v-select
                        id="fromc"
                        @input="(v)=>{pair.targetCurrency=v;}"
                        :options="selectableCurrencies"
                        :value="pair.targetCurrency"
                    ></v-select></td>
                    <td><input type="text" pattern="[0-9]+([\.,][0-9]+)?" step="0.00000001" v-model="pair.exchangeRate" @keypress="validateRate" @change="validateRate"></td>
                </tr>
                </tbody>
            </table>
            <pd-button v-if="selectedExchangeRateSnapshot!=null && !selectedExchangeRateSnapshot.frozen" label="+"
                       :click="addRate"></pd-button>

        </div>

        <div class="buttonbar" v-if="canCreateSnapshot">
            <pd-button v-if="selectedExchangeRateSnapshot==null || selectedExchangeRateSnapshot.frozen" label="New"
                       :click="createSnapshot"></pd-button>
            <pd-button v-if="selectedExchangeRateSnapshot!=null && !selectedExchangeRateSnapshot.frozen" label="Save"
                       :click="saveSnapshot"></pd-button>
            <pd-button v-if="selectedExchangeRateSnapshot!=null && !selectedExchangeRateSnapshot.frozen" label="Cancel"
                       :click="cancelSnapshotCreation"></pd-button>
        </div>
    </div>

</template>


<script>
    import {mapGetters, mapState} from 'vuex';
    import Button from "../components/button.vue";
    import {ExchangeRateSnapshot, Rate} from "@/store/CurrencyStore";

    export default {
        name: 'Currencies',
        props: {
            msg: String
        },
        components: {
            "pd-button": Button
        },
        computed: {
            ...mapState("currencyStore", [
                "exchangeRateSnapshots",
                "selectedExchangeRateSnapshot",
                "programs",
                "selectedProgram"
            ]),
            ...mapGetters('currencyStore', [
                "exchangeRateSnapshots",
                "selectedExchangeRateSnapshot",
                "programs",
                "selectedProgram",
                "canCreateSnapshot",
                "selectableCurrencies"
            ])
        },
        methods: {
            replaceComma(input){
                return input.replace(/,/g, ".");
            },
            validateRate(e){
                if(e.keyCode <44 || e.keyCode>57){
                    e.preventDefault();
                }
                this.$nextTick(() => {
                    e.target.value = this.replaceComma(e.target.value);
                });

            },
            formatDate(exchangeRateSnapshot){
                const lang = navigator.language;
                let res = new Date(exchangeRateSnapshot.snapshotTime).toLocaleDateString(lang,
                    {day:"2-digit", month:"2-digit",year:"numeric", hour:"2-digit", minute:"2-digit",second:"2-digit"});

                if(exchangeRateSnapshot.snapshotComment){
                    res += " | " + exchangeRateSnapshot.snapshotComment;
                }

                return res;
            },
            setActiveSnapshot(val) {
                this.$store.commit('currencyStore/setActiveSnapshot', val)
            },
            setActiveProgram(val){
                this.$store.commit('currencyStore/setActiveProgram', val)
            },
            createSnapshot() {
                let snap = this.selectedExchangeRateSnapshot;
                if (!snap) {
                    snap = new ExchangeRateSnapshot();
                } else {
                    snap = JSON.parse(JSON.stringify(snap));
                }
                snap.frozen = false;
                snap.snapshotTime = Date.now();
                this.$store.commit('currencyStore/setActiveSnapshot', snap)
            },
            cancelSnapshotCreation() {
                this.$store.commit('currencyStore/setActiveSnapshot', null);
            },
            saveSnapshot() {
                let snap = this.selectedExchangeRateSnapshot;
                snap.frozen = true;
                this.$store.commit('currencyStore/addSnapshot', snap)
            },
            addRate() {
                let snap = this.selectedExchangeRateSnapshot;
                snap.rates.push(new Rate())
            }
        },
        created() {
            this.$store.commit('currencyStore/loadFromDb');
        }
    }
</script>